import { Grid } from "@mui/material";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

import MetaTags from "../components/Common/MetaTags";
import Headline from "../components/Common/Headline";
import TestimonialCard from "../components/Common/TestimonialCard/TestimonialCard";
import importAll from "../lib/utils/image";

export default function Testimonials() {
  const { t } = useTranslation("testimonials");
  const blocks = t("testimonials.blocks", { returnObjects: true });
  const allImages = importAll(
    require.context(
      "../public/static/images/home/testimonials/",
      false,
      /\.(png|jpe?g|svg)$/
    )
  );

  return (
    <>
      <MetaTags scope="testimonials" />

      <Headline
        title1={t("testimonials.title1")}
        title2={t("testimonials.title2")}
        subtitle={t("testimonials.subtitle")}
      >
        <Grid container spacing={2}>
          {blocks.map((item, i) => (
            <Grid item key={i}>
              <TestimonialCard
                fullName={item.full_name}
                content={item.content}
                job={item.job}
                image={allImages[item.image]}
                key={item.full_name}
              />
            </Grid>
          ))}
        </Grid>
      </Headline>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "testimonials"])),
    },
  };
}
